import React, { useState } from "react";
import s from "./Footer.module.scss";
import { Col, Form, Input, Row, message as antdMessage } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
import useWindowDimensions from "../WindowDimensions/WindowDimensions";
import { publicRequest } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/i18n";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { Language } from "../Header/Header";
import { getContactLinks, setLang } from "../../redux/InformationSlice";
import { RootState } from "../../redux/store";
import { buildContactLinksMap } from "../../utils/contactLinks";

const Footer = () => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const params = useParams();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const [sending, setSending] = React.useState(false);
  const dispatch: AppDispatch = useDispatch();
  const contactLinks = useSelector((state: RootState) => state.info.contactLinks);
  const [selected, setSelected] = useState("RU");
  const links = React.useMemo(
    () => buildContactLinksMap(contactLinks),
    [contactLinks],
  );

  React.useEffect(() => {
    if (!contactLinks?.length) {
      dispatch(getContactLinks());
    }
  }, [dispatch, contactLinks]);

  const onFinish = async (values: any) => {
    try {
      setSending(true);
      await publicRequest.post("/api/v1/feedback/", {
        name: values?.name,
        email: values?.email,
        telegram: values?.telegram,
        message: values?.message,
      });
      antdMessage.success(t("Сообщение отправлено"));
      form.resetFields();
    } catch (e) {
      antdMessage.error(t("Не удалось отправить сообщение"));
    } finally {
      setSending(false);
    }
  };

  const selectLanguage = (lang: "RU" | "KG" | "UZ" | "TJ") => {
    setSelected(lang);

    i18n.changeLanguage(lang?.toLowerCase());
    dispatch(setLang(lang?.toLowerCase()));
  };

  return (
    <div>
      {location.pathname === "/" || location.pathname === "/about" ? null : (
        <div className={s.footer_yellow_top}>
          <img src="/images/yellow_top.svg" className={s.yellow_top} />
        </div>
      )}

      <div className={s.footer}>
        <div className={s.footer_top}>
          <Link to="/" aria-label="Vputi home">
            <img src="/images/footer_img.svg" alt="Logo" className={s.logo} />
          </Link>
        </div>

        <div className={s.content}>
          <div className={s.black}>
            <div className={s.h2}>{t("СВЯЖИТЕСЬ С НАМИ")}</div>
          </div>
          <div className={s.description}>
            {t(
              "Если остались вопросы, то свяжитесь с нами. Мы готовы вам помочь БEСПЛАТНО.",
            )}
          </div>

          <div className={s.feedback}>
            <div className={s.buttons}>
              <div className={s.form_title}>{t("Контактная информация")}</div>
              <div className={s.form_subtitle}>vputicentralasia@gmail.com</div>
              <div className={s.form_btns}>
                <Link
                  to={links.consultant}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={s.form_btn}
                >
                  {" "}
                  <img
                    src="/images/telegram.svg"
                    className={s.icon}
                    alt=""
                  />{" "}
                  {t("Связаться с консультантом")}
                </Link>
                <Link
                  to={links.jurist}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={s.form_btn}
                >
                  <img src="/images/telegram.svg" className={s.icon} alt="" />
                  {t("Связаться с юристом")}
                </Link>
                <Link
                  to={links.ai}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={s.form_btn}
                >
                  {" "}
                  <img src="/images/telegram.svg" className={s.icon} alt="" />
                  {t("Чат с ИИ")}
                </Link>
              </div>
            </div>
            <div className={s.form}>
              <div className={s.form_title}>{t("Форма обратной связи")}</div>
              <Form
                className={s.form}
                layout="vertical"
                form={form}
                onFinish={onFinish}
              >
                <Row gutter={width > 600 ? [24, 24] : [24, 6]}>
                  <Col span={24}>
                    <Form.Item
                      name="name"
                      label={
                        <div className={s.label}>
                          {t("Имя (необязательно)")}
                        </div>
                      }
                    >
                      <Input className={s.input} placeholder={t("Ваше имя")} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={width > 600 ? [24, 24] : [24, 0]}>
                  <Col span={width > 1070 ? 12 : 24}>
                    <Form.Item
                      name="email"
                      label={<div className={s.label}>{t("E-mail")}</div>}
                      rules={[
                        {
                          type: "email",
                          message: t("Введите корректный email"),
                        },
                      ]}
                    >
                      <Input
                        className={s.input}
                        placeholder={t("Ваш e-mail")}
                      />
                    </Form.Item>
                  </Col>
                  <div className={s.or}>{t("или")}</div>
                  <Col span={width > 1070 ? 11 : 24}>
                    <Form.Item
                      name="telegram"
                      label={<div className={s.label}>Telegram</div>}
                    >
                      <Input
                        className={s.input}
                        placeholder={t("Ваш telegram")}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={width > 600 ? [24, 24] : [24, 6]}>
                  <Col span={24}>
                    <Form.Item
                      label={
                        <div className={s.label}>{t("Ваше сообщение")}</div>
                      }
                      name="message"
                      rules={[
                        {
                          required: true,
                          message: t("Ваше сообщение не может быть пустым"),
                        },
                      ]}
                    >
                      <TextArea
                        className={s.input}
                        style={{ minHeight: "100px" }}
                        placeholder={t("Напишите ваше сообщение")}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <button
                  type="submit"
                  className={s.form_btn}
                  style={{ display: "flex", justifyContent: "center" }}
                  disabled={sending}
                >
                  {sending ? t("Отправка...") : t("Отправить")}
                </button>
              </Form>
            </div>
          </div>
        </div>
        <div className={s.bottom_wrapper}>
          <div className={s.bottom}>
            <div className={s.bottom_logo}>
              <Link to="/" aria-label="Vputi home">
                <img
                  src="/images/logo_dark.svg"
                  alt="Logo"
                  className={s.bottom_logo_img}
                />
              </Link>
            </div>
            <div className={s.info}>
              {t(
                "Информация собрана из открытых источников и проверена медицинскими специалистами в августе 2025 года. Контент имеет справочный характер",
              )}
            </div>
            <div className={s.ai_lang}>
              <div className={s.lang_buttons}>
                <div
                  className={s.lang_button}
                  onClick={() => selectLanguage("RU")}
                >
                  RU
                </div>
                <div
                  className={s.lang_button}
                  onClick={() => selectLanguage("KG")}
                >
                  KG
                </div>
                <div
                  className={s.lang_button}
                  onClick={() => selectLanguage("UZ")}
                >
                  UZ
                </div>
                <div
                  className={s.lang_button}
                  onClick={() => selectLanguage("TJ")}
                >
                  TJ
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
